/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { Blacklistable, BlacklistableInterface } from '../../FiatTokenV1.sol/Blacklistable';

const _abi = [
  {
    constant: false,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'unBlacklist',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'owner',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newBlacklister',
        type: 'address',
      },
    ],
    name: 'updateBlacklister',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'blacklister',
    outputs: [
      {
        name: '',
        type: 'address',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'blacklist',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {
        name: '_account',
        type: 'address',
      },
    ],
    name: 'isBlacklisted',
    outputs: [
      {
        name: '',
        type: 'bool',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: '_account',
        type: 'address',
      },
    ],
    name: 'Blacklisted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: '_account',
        type: 'address',
      },
    ],
    name: 'UnBlacklisted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newBlacklister',
        type: 'address',
      },
    ],
    name: 'BlacklisterChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
];

const _bytecode =
  '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';

type BlacklistableConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: BlacklistableConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class Blacklistable__factory extends ContractFactory {
  constructor(...args: BlacklistableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'Blacklistable';
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<Blacklistable> {
    return super.deploy(overrides || {}) as Promise<Blacklistable>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Blacklistable {
    return super.attach(address) as Blacklistable;
  }
  override connect(signer: Signer): Blacklistable__factory {
    return super.connect(signer) as Blacklistable__factory;
  }
  static readonly contractName: 'Blacklistable';

  public readonly contractName: 'Blacklistable';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BlacklistableInterface {
    return new utils.Interface(_abi) as BlacklistableInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Blacklistable {
    return new Contract(address, _abi, signerOrProvider) as Blacklistable;
  }
}
